import React, { useMemo } from "react"
import { useGetHistoryCalendar } from "../../../../api/history"
import { Calendar } from "../../../Calendar"
import { useTodayState } from "../../../Calendar/core"

export const Section_History_Calendar = ({
  deviceId,
  date,
  setDate,
}: {
  deviceId: number,
  date: string,
  setDate: React.Dispatch<React.SetStateAction<string>>,
}) => {
  const
  [state, setState] = useTodayState(),
  apiParams = useMemo(() => {
    return {
      deviceId,
      schDate: state.split("-").slice(0, 2).join("-")
    }
  }, [deviceId, state]),
  {data: dayIndicatorSet} = useGetHistoryCalendar(apiParams)

  const onEvent = ({data}: any) => {
    try {
      if (data) {
        if (data.domain == "day") {
          const selectedDateStr = data.selectedDateValues.dateStr
          if (selectedDateStr != date)
            if (dayIndicatorSet?.has(selectedDateStr))
              setDate(selectedDateStr)

          const locationCalendarKey = data.locationDateValues.calendarKey
          if (locationCalendarKey != state)
            setState(locationCalendarKey)
        }
      }

    } catch (e) {
      console.error("CalendarBox.onEvent > ", e)
    }
  }

  return (
    <section className="Calendar">
      <Calendar
        selectedDate={date}
        dayIndicatorSet={dayIndicatorSet}
        hasToday={true}
        onEvent={onEvent}
      />
    </section>
  )
}